import React from 'react';
import { Header, Footer, Form } from '../components/common';
import { homePageContent } from '../content/homePage';
import { useContactForm } from '../utils/contactForm';
import udemyCoursesData from '../data/udemyCourses.json';
import '../components/common/PageLayout.css';
import './Resources.css';

const { form } = homePageContent;

const YOUTUBE_PLAYLISTS = [
  { id: 'PLX5odFI2hPd7poCH1JC7hwR-a3ueMuZar', title: 'Agentforce Wala Course' },
  { id: 'PLX5odFI2hPd7JDGLJmMDxYej8nYVXOrWd', title: 'Lightning Web Component (LWC KIT)' },
];

const DEFAULT_UDEMY_IMAGE = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=480&h=270&fit=crop';

const UDEMY_COURSES = udemyCoursesData;

const Resources = () => {
  const { submitStatus, handleSubmit, errorMessage } = useContactForm();

  return (
  <>
    <div className="hero-gradient-wrap">
      <Header ctaText="Join Community" ctaPath="#courses" />
      <section className="page-hero">
        <h1>Resources</h1>
        <p>Guides, tools, and materials to support your learning and teaching journey.</p>
      </section>
    </div>
    <main className="page-layout-main">
      <section className="page-section">
        <h2>YouTube</h2>
        <p>Watch our curated playlists to supplement your learning.</p>
        <div className="resources-youtube-wrap">
          {YOUTUBE_PLAYLISTS.map((playlist) => (
            <div key={playlist.id} className="resources-embed-card">
              <h3 className="resources-playlist-title">{playlist.title}</h3>
              <div className="resources-embed-aspect">
                <iframe
                  title={`${playlist.title} – YouTube Playlist`}
                  src={`https://www.youtube.com/embed/videoseries?list=${playlist.id}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="resources-embed-iframe"
                />
              </div>
              <a href={`https://www.youtube.com/playlist?list=${playlist.id}`} target="_blank" rel="noopener noreferrer" className="resources-playlist-link">
                Open playlist on YouTube →
              </a>
            </div>
          ))}
        </div>
      </section>

      <section className="page-section">
        <h2>Udemy</h2>
        <p>Access our courses and learning paths on Udemy.</p>
        <div className="resources-udemy-wrap resources-udemy-grid">
          {UDEMY_COURSES.map((course, i) => (
            <a
              key={i}
              href={course.url}
              target="_blank"
              rel="noopener noreferrer"
              className="page-card resources-udemy-card resources-udemy-link-card"
            >
              <div className="resources-udemy-card-image-wrap">
                <img
                  src={course.image || DEFAULT_UDEMY_IMAGE}
                  alt=""
                  className="resources-udemy-card-image"
                />
              </div>
              <div className="resources-udemy-card-body">
                <h3>{course.title}</h3>
                <span className="resources-udemy-cta">View on Udemy →</span>
              </div>
            </a>
          ))}
        </div>
      </section>

      <Form
        title={form.title}
        subtitle={form.subtitle}
        onSubmit={handleSubmit}
        submitStatus={submitStatus}
        errorMessage={errorMessage}
      />
    </main>
    <Footer />
  </>
  );
};

export default Resources;
